var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "opt-group", staticStyle: { width: "165px" } },
    [
      _c(
        "i",
        {
          staticClass: "iconBtn el-icon-view opt-button",
          on: { click: _vm.handleViewDetail },
        },
        [_vm._v(_vm._s(_vm.$t("status.viewDetail")))]
      ),
      _vm._v(" "),
      _vm.record.authStatus == "2"
        ? _c(
            "i",
            {
              staticClass: "iconBtn el-icon-remove-outline opt-button",
              on: { click: _vm.handleCancel },
            },
            [_vm._v(_vm._s(_vm.$t("roleCertificationApplication.cancel")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.record.authStatus == "0" ||
      _vm.record.authStatus == "3" ||
      _vm.record.authStatus == "4"
        ? _c(
            "i",
            {
              staticClass: "iconBtn el-icon-edit-outline opt-button",
              attrs: { title: _vm.$t("roleCertificationApplication.edit") },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v(_vm._s(_vm.$t("roleCertificationApplication.edit")))]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }